var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPointed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9831 7.32281L6.36614 12.9398L6.10214 15.8958L9.07914 15.6248L14.6791 10.0188L11.9831 7.32281ZM17.9661 6.72881L15.2711 4.03481L13.3231 5.98281L16.0181 8.67881L17.9661 6.72881ZM5.09114 17.9958C5.06014 17.9988 5.03014 17.9998 5.00014 17.9998C4.73614 17.9998 4.48114 17.8958 4.29314 17.7068C4.08314 17.4968 3.97714 17.2048 4.00414 16.9098L4.38314 12.7388C4.42514 12.2818 4.62714 11.8508 4.95214 11.5258L13.9481 2.52881C14.6501 1.82481 15.9241 1.85981 16.6641 2.59881L19.4021 5.33681H19.4031C20.1691 6.10381 20.1991 7.32081 19.4711 8.05081L10.4741 17.0478C10.1491 17.3738 9.71914 17.5748 9.26114 17.6168L5.09114 17.9958ZM5 19.9999H19C19.55 19.9999 20 20.4499 20 20.9999C20 21.5499 19.55 21.9999 19 21.9999H5C4.45 21.9999 4 21.5499 4 20.9999C4 20.4499 4.45 19.9999 5 19.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPointed);
export default __webpack_public_path__ + "static/media/EditPointed.2c7a51361703b26a92bdf07dc906e866.svg";
export { ForwardRef as ReactComponent };